export default function WhenIcon() {
  return (
    <svg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9 6.3125V9.5L11.0625 11.5625M15.9375 9.5C15.9375 13.3315 12.8315 16.4375 9 16.4375C5.16852 16.4375 2.0625 13.3315 2.0625 9.5C2.0625 5.66852 5.16852 2.5625 9 2.5625C12.8315 2.5625 15.9375 5.66852 15.9375 9.5Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
